import React from 'react';
import PropTypes from 'prop-types';

import {Title, Box} from 'views/components';

const ClientLeadNameView = (props) => {
  const {
    clientLeadData,
    setIsEditing,
  } = props;

  const clientLeadName = clientLeadData.clientLeadName;

  return (
    <Box
      sx={{
        cursor: 'pointer',
      }}
      onClick={() => setIsEditing(true)}
    >
      <Title disableDivider sx={{my: '8px', fontWeight: 'bold'}}>
        {clientLeadName}
      </Title>
    </Box>
  );
};

ClientLeadNameView.propTypes = {
  clientLeadData: PropTypes.object.isRequired,
  setIsEditing: PropTypes.func.isRequired,
};

export default React.memo(ClientLeadNameView);
